import { Divider as MuiDivider, DividerProps } from '@mui/material';

const Divider = ({ ...rest }: DividerProps) => <MuiDivider {...rest} />;

export default Divider;
